import { useEffect, useState } from "react";
import Select from 'react-select';

function PaymentMadeTaxSelect(props) {
    const customStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: 42,
            borderColor: state.isFocused ? '#3b82f6' : '#cbd5e1',
            boxShadow: state.isFocused ? '0 0 0 2px rgba(59, 130, 246, 0.5)' : 'none',
            '&:hover': {
                borderColor: '#3b82f6'
            },
            borderRadius: '0.5rem',
            fontSize: '0.875rem'
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
            borderRadius: '0.5rem',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            overflow: 'hidden'
        }),
        menuList: (base) => ({
            ...base,
            padding: 0,
            maxHeight: '300px'
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected 
                ? '#3b82f6' 
                : state.isFocused 
                    ? '#dbeafe' 
                    : 'white',
            color: state.isSelected ? 'white' : '#1e293b',
            padding: '10px 12px',
            cursor: 'pointer',
            fontSize: '0.875rem',
            '&:active': {
                backgroundColor: '#3b82f6'
            }
        }),
        placeholder: (base) => ({
            ...base,
            color: '#94a3b8',
            fontSize: '0.875rem'
        }),
        singleValue: (base) => ({
            ...base,
            color: '#1e293b',
            fontSize: '0.875rem'
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: '#64748b',
            '&:hover': {
                color: '#3b82f6'
            }
        }),
        indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: '#cbd5e1'
        })
    };

    const [list, setList] = useState([]);

    useEffect(() => {
        if (list?.length < 1 && props?.list?.length > 0) {
            const customOption = props.list.map((war) => {
                return { ...war, label: `${war.account_name}`, value: war.account_id };
            });
            setList(customOption);
        }
    }, [list?.length, props?.list]);

    function itemInInput(item) {
        props.selected(item);
    }

    return (
        <div className="w-full">
            <Select 
                placeholder="Select Warehouse" 
                defaultValue={{label: props?.defaultValue}}
                styles={customStyles} 
                onChange={itemInInput} 
                options={list}
                menuPortalTarget={document.body}
                menuPosition="fixed"
            />
        </div>
    );
}

export default PaymentMadeTaxSelect;